var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("PortalWidget", { attrs: { widget: _vm.widgetTitle } }, [
    _c(
      "div",
      [
        !_vm.loading && !_vm.addButtonDisabled
          ? _c("div", { staticClass: "m-b-15" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success btn-sm",
                  attrs: { type: "button", disabled: _vm.addButtonDisabled },
                  on: { click: _vm.displayNewForm }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ADD_MFA_METHOD",
                        expression: "'ADD_MFA_METHOD'"
                      }
                    ]
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "v-table",
          {
            staticClass: "table_beauty",
            attrs: { data: _vm.enabledMFAMethods, "hide-sort-icons": true },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function({ displayData }) {
                  return _c(
                    "tbody",
                    {},
                    [
                      _vm.showAddNewForm
                        ? _c(
                            "tr",
                            {
                              staticClass:
                                "row-inline-new-form slide-down bg-row-even"
                            },
                            [
                              _c(
                                "td",
                                { attrs: { colspan: "100" } },
                                [
                                  _c("TwoFactorAuthMFAForm", {
                                    on: { hideDetailsForm: _vm.hideDetailsForm }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(displayData, function(row) {
                        return [
                          _c("tr", { key: row.type }, [
                            _c("td", [_vm._v(_vm._s(row.label))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "div",
                                { staticClass: "actions-collapsed-list" },
                                [
                                  _c("div", { staticClass: "action-icon" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-list-function",
                                        on: {
                                          click: function($event) {
                                            return _vm.onUpdateMethodClick(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.bottom.hover",
                                              value: {
                                                text: _vm.$t(
                                                  "MFA_ACTIONS_UPDATE"
                                                ),
                                                transition: 0
                                              },
                                              expression:
                                                "{text:$t('MFA_ACTIONS_UPDATE'), transition: 0}",
                                              modifiers: {
                                                bottom: true,
                                                hover: true
                                              }
                                            }
                                          ],
                                          staticClass: "typcn typcn-edit",
                                          attrs: { "aria-hidden": "true" }
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "UPDATE",
                                              expression: "'UPDATE'"
                                            }
                                          ],
                                          staticClass: "hint-text-mobile"
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]
                      })
                    ],
                    2
                  )
                }
              }
            ])
          },
          [
            _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
              _c(
                "tr",
                [
                  _c("v-th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "PAGE_TITLE",
                        expression: "'PAGE_TITLE'"
                      }
                    ],
                    attrs: { "sort-key": "type" }
                  }),
                  _vm._v(" "),
                  _c("v-th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "ACTIONS",
                        expression: "'ACTIONS'"
                      }
                    ],
                    attrs: { "sort-key": "location" }
                  })
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _vm.loading
          ? _c(
              "div",
              { staticClass: "well well-sm text-center m-t-20" },
              [
                _c("Loader"),
                _vm._v(" "),
                _c("span", {
                  directives: [
                    {
                      name: "t",
                      rawName: "v-t",
                      value: "TABLE_LOADING",
                      expression: "'TABLE_LOADING'"
                    }
                  ]
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.emptyMfaMethods
          ? _c("div", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "MFA_METHODS_TABLE_EMPTY",
                  expression: "'MFA_METHODS_TABLE_EMPTY'"
                }
              ],
              staticClass: "well well-sm text-center m-t-20"
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }